import {
	SheetContentType,
	useSheetStore,
} from "@/dentlab/src/store/Sheets/sheet.store";
import { JobRequestSheetContentProps } from "../sheet-contents/job-request-sheet/JobRequestSheetContent";

export const useJobRequestSheet = () => {
	const { openSheet } = useSheetStore();

	const openJobRequestSheet = (props: JobRequestSheetContentProps) => {
		openSheet(SheetContentType.JOB_REQUEST, {
			jobTitle: props.jobTitle,
			jobId: props.jobId,
			onSubmit: props.onSubmit,
		});
	};

	return { openJobRequestSheet };
};
